import Section from '../components/section/Section';
import photo from '../img/AdobeStock_332078583-2.png';

export default function EmbTest() {
    return (
      <>
        <div className="content">
            {/* <div class="emb-banner"></div> */}
            <Section color={"green"}>
                <div className="col-xs-12">
                    <div className="box">
                        <h1 className="margin-bottom-20">EMB Test</h1>
                        <p className="padding-left-20 padding-right-20 margin-bottom-20">
                            Heb je altijd al eens een energetische bloedtest willen laten doen om te kijken of je eventueel tekorten en/of verstoringen in je lichaam hebt? Of heb je al een tijdje last van (vage) klachten waar je geen duidelijke oorzaak voor gevonden krijgt? Dan is de Energetische Morfologische Bloedtest (EMB) iets voor jou!
                        </p>
                        <button class="button margin-top-20">Contact</button>
                    </div>
                </div>
            </Section>
            <Section>
                <div className="col-md-6">
                    <div className="box">
                        <h2 className="margin-bottom-20">Met welke klachten kan ik je helpen?</h2>
                        <ul className="list text-left">
                            <li>Hormonale klachten (PMS, PCOS, uitblijvende/onregelmatige menstruatiecyclus, kinderwens, overgangsklachten, etc.)</li>
                            <li>Darmklachten (Prikkelbare darm syndroom, opgeblazen gevoel, obstipatie, etc.)</li>
                            <li>Vermoeidheid en futloosheid</li>
                            <li>Huidklachten (acné, eczeem, psoriasis, etc.)</li>
                            <li>Slaapproblemen</li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="box">
                        <img src={photo} alt="nutrition" />
                    </div>
                    </div>
            </Section>
            <Section color={"pink"}>
                <div className="col-md-6">
                    <div className="box">
                        <h2 className="margin-bottom-20">Hoe ga ik te werk</h2>
                        <ol className="list-ordered text-left">
                            <li>Door middel van een vingerprik neem ik wat bloed bij je af. Er is weinig bloed voor nodig dus dit is zo gedaan.</li>
                            <li>Ik stuur het bloed op naar het laboratorium van de EMB Test waar het wordt geanalyseerd door experts.</li>
                            <li>Binnen 3 weken ontvang ik je testuitslag. Op basis van deze uitslag en jouw gegevens van de intake, maak ik een passend voedings-, suppletie- en leefstijladvies.</li>
                            <li>Je krijgt de EMB testuitslag en alle bijbehorende informatiedocumenten via de mail toegestuurd. Zo kan je thuis alles nog eens rustig doornemen.</li>
                            <li>Na 6 weken mag je me via de mail een update sturen over hoe het met je gaat. Hierop krijg je advies van mij via de mail.</li>
                        </ol>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="box">          
                        <h2 className="margin-bottom-20">Wat wordt er gemeten?</h2>
                        <ul className="list text-left"> 
                            <li><strong>Vitaminen</strong> (B12, D, foliumzuur, etc.)</li>
                            <li><strong>Mineralen </strong>(magnesium, jodium, zink etc.)</li>
                            <li><strong>Vetzuren balans </strong>(omega 3 en 6)</li>
                            <li><strong>pH waarde </strong>(zuurtegraad van je lichaam)</li>
                            <li><strong>Hormonale balans </strong>(oestrogeen, progesteron, testosteron, insuline, etc.)</li>
                            <li><strong>Darmparameters </strong>(darmflora, bacteriën, schimmels, parasieten, etc.)</li>
                            <li><strong>Neurotransmitters </strong>(acetylcholine, dopamine, GABA, serotonine)</li>
                            <li><strong>Stress parameters </strong>(endorfinen, verlengde stressreactie, cortisol, etc.)</li>
                            <li><strong>Spijsvertering </strong>(maag, alvleesklier, lever, etc.)</li>
                            <li><strong>Toxische belasting </strong>(afvalstoffen)</li>
                            <li><strong>Elektrosmog </strong>(5G, WiFi straling, zendmasten, etc.)</li>
                            <li><strong>Voedselintoleranties </strong>(gluten, lactose, koemelk, soja, etc.)</li>
                        </ul>
                    </div>
                </div>
            </Section>
        </div>
      </>
    );
  }